import { render } from "./RecentOverview.vue?vue&type=template&id=11927672"
import script from "./RecentOverview.vue?vue&type=script&lang=js"
export * from "./RecentOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__